// extracted by mini-css-extract-plugin
export default {"container":"CartElement_container__H7Teq","left_box":"CartElement_left_box__grau3","delete":"CartElement_delete__rv--c","status":"CartElement_status__Iy8gU"};